import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/messagesPage';

import { sendMessage } from './utils';

export default function* listenSendMessage() {
  yield takeEvery(actions.sendMessage.toString(), sendMessage);
}
